/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Icon.scss'
import React from 'react'

function Icon(props) {
  const className = props.className || ''
  const type = props.type ? 'icon-' + props.type : ''
  const alt = props.alt || ''
  const onClickAction = props.onClick
  return <div className={`icon ${type} ${className}`} alt={alt} onClick={onClickAction} />
}

export default Icon
